/**
 * 
 * Call the function to get cart data and update the cart drawer
 */
document.addEventListener('cart:updated', () => {
    getCartDataAndUpdate();
    
    updateDrawerShippingBar();
    
    console.log('Cart updated');
});


if (!customElements.get("UpsellCarousel")) {
    class UpsellCarousel extends HTMLElement {
        constructor() {
            super();
            this.currentIndex = 0;
        }

        connectedCallback() {
            this.slideSelector = this.getAttribute('slide-selector') || '.product-card';
            this.nextBtnSelector = this.getAttribute('next-btn-selector') || '.next-btn';
            this.prevBtnSelector = this.getAttribute('prev-btn-selector') || '.prev-btn';
            this.paginationSelector = this.getAttribute('pagination-selector') || '#pagination';

            this.slideContainer = this.querySelector('mm-upsell-carousel mm-upsell .carousel-slide');
            this.slides = this.querySelectorAll(this.slideSelector);
            this.nextBtn = this.querySelector(this.nextBtnSelector);
            this.prevBtn = this.querySelector(this.prevBtnSelector);
            this.pagination = this.querySelector(this.paginationSelector);

            if (!this.slideContainer || this.slides.length === 0) return;

            this.initCarousel();
        }

        initCarousel() {
            this.updateSlide();

            this.nextBtn?.addEventListener('click', () => {
                this.currentIndex = (this.currentIndex + 1) % this.slides.length;
                this.updateSlide();
            });

            this.prevBtn?.addEventListener('click', () => {
                this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
                this.updateSlide();
            });

            this.slides.forEach((_, index) => {
                const dot = document.createElement('span');
                dot.classList.add('dot');
                if (index === 0) dot.classList.add('active');
                dot.addEventListener('click', () => {
                    this.currentIndex = index;
                    this.updateSlide();
                });
                this.pagination?.appendChild(dot);
            });
        }

        updateSlide() {
            this.slideContainer.style.transform = `translateX(-${this.currentIndex * 100}%)`;
            this.updateDots();
        }

        updateDots() {
            this.querySelectorAll('.dot').forEach((dot, index) => {
                dot.classList.toggle('active', index === this.currentIndex);
            });
        }
    }
    customElements.define('mm-upsell-carousel', UpsellCarousel);
}

if (!customElements.get("mm-upsell")) {
    class MMProductUpsell extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.init();
        }
        disconnectedCallback() {
            //console.log('MMProductUpsell component removed!');
        }
        init() {
            //console.log('MMProductUpsell component initialized!');
            const slideContainer = this.querySelector('.carousel-slide');
            const product_card = this.querySelectorAll('.product-card');
            const btnAdd = this.querySelectorAll('button.add-to-cart');
            const optVariants = this.querySelectorAll('.variant-select');

            optVariants.forEach(select => {
                const button = select.closest(".product-card")?.querySelector(".add-to-cart");
                const priceBox = select.closest(".product-card")?.querySelector(`[data-target="price-element"]`);
                //const priceBox = select.closest(".product-price");

                function updateButtonState() {
                    const selectedOption = select.options[select.selectedIndex];
                    const price = selectedOption.dataset.price;
                    const isAvailable = selectedOption.dataset.available === "true";
                    //console.log('isAvailable', isAvailable, price, priceBox);
                    if (priceBox) {
                        priceBox.textContent = window.shopCurrencySymbol + price;
                    }
                    if (button) {
                        button.disabled = !isAvailable;
                        button.querySelector('span').textContent = isAvailable ? "Add" : "Sold Out";
                    }
                }

                select.addEventListener("change", updateButtonState);
                updateButtonState(); // Initial check on page load
            });

            btnAdd.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    const card = event.target.closest('.product-card');
                    const product = card.dataset.name;
                    const variant = card.querySelector('.variant-select').value;
                    //console.log(`Added ${product} (${variant}) to cart!`);
                    event.preventDefault();
                    this.disableLoadingInButton(btn);
                    this.addToCart(card);
                });
            });
        }
        disableLoadingInButton(btn) {
            btn.classList.remove("loading");
            btn.querySelector("span").classList.add("hidden");
            btn.querySelector(".loading-overlay__spinner").classList.remove("hidden");
        }
        enableLoadingInButton(btn) {
            btn.classList.remove("loading");
            btn.querySelector("span").classList.remove("hidden");
            btn.querySelector(".loading-overlay__spinner").classList.add("hidden");
        }
        addToCart(card) {
            const variantId = card.querySelector(".variant-select").value;
            const btn = card.querySelector(".add-to-cart");
            const _cartdrawer = document.querySelector("cart-drawer");

            _cartdrawer?.setActiveElement(document.activeElement);

            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            delete config.headers["Content-Type"];

            const formData = new FormData(card.querySelector("form"));
            formData.append(
                "sections",
                _cartdrawer.getSectionsToRender().map((section) => section.id),
            );
            formData.append("sections_url", window.location.pathname);
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then(res => res.json())
                .then(data => {
                    setTimeout(() => {
                        console.log("Add to cart success:", data.status);
                        this.enableLoadingInButton(btn);
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: "product-form",
                            productVariantId: variantId,
                            cartData: data,
                        });
                        let isClosedCart = !document.body.classList.contains('page-overlay-cart-on');

                        console.log('Cart', _cartdrawer, isClosedCart);
                        _cartdrawer.renderContents(data, isClosedCart);
                        this.redirectAfterSubmit(data, isClosedCart = true);
                        this.enableLoadingInButton(btn);


                        const body = document.body;
                        const overlay = document.querySelector('.wt__quick-buy--page-overlay');
                        const cartDrawerWrapper = document.querySelector("cart-drawer");
                        //overlay.classList.add('wt__quick-buy--page-overlay--open');
                        //body.classList.add('quick-buy-page-overlay');
                        cartDrawerWrapper.toggleDrawerClasses();

                    }, 300);
                })
                .catch(err => {
                    console.error("Add to cart failed:", err);
                    button.textContent = "Error";
                    button.disabled = false;
                });
        }
        redirectAfterSubmit(response, isClosedCart = true) {
            const body = document.body;
            const isCartPage = body.classList.contains('template-cart')
            const _cartdrawer = document.querySelector("cart-drawer");
            const cartType = _cartdrawer?.dataset.cartType;

            console.log('isCartPage', this.cartType, isCartPage);
            if (cartType === 'drawer' && isCartPage) {
                const overlay = document.querySelector('.wt__quick-buy--page-overlay');
                overlay.classList.remove('wt__quick-buy--page-overlay--open')
                body.classList.remove('quick-buy-page-overlay')
            } else if (cartType === 'drawer') {
                //console.log('isCartPage', response);
                _cartdrawer.renderContents(response, isClosedCart);
                return;
            }
            window.location = window.routes.cart_url;
        }
    }
    customElements.define("mm-upsell", MMProductUpsell);
}

document.addEventListener('click', function (e) {
    if (e.target && e.target.matches('button.needsclick') && e.target.closest('div[role="dialog"].needsclick')) {
        const klaviyo_frm_popup = document.querySelector('div[role="dialog"].needsclick');
        if (klaviyo_frm_popup) {
            const buttonText = e.target.textContent.trim();
            if (buttonText === 'Back to site' || buttonText === 'I’ll pay full price') {
                klaviyo_frm_popup.style.display = 'none';
            }
        }
    }
});

/**
 * Calculate cart free shipping threshold
 */

const FREE_SHIPPING_THRESHOLD = 1; // Get this value from your theme settings

function updateDrawerShippingBar() {
    fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            const total = cart.total_price / 100;
            const percent = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);
            const cart_shipping = document.querySelector('.wt-free-shipping-bar .wt-free-shipping-text');
            const cart_progress_bar = document.querySelector('.wt-free-shipping-bar .wt-progress-bar__fill');

            if (!cart_shipping || !cart_progress_bar) return;

            if (total >= FREE_SHIPPING_THRESHOLD) {
                cart_shipping.innerText = "You've unlocked free shipping!";
            } else {
                const remaining = (FREE_SHIPPING_THRESHOLD - total).toFixed(2);
                cart_shipping.innerText = `You're $${remaining} away from free shipping`;
            }
            cart_progress_bar.style.width = percent + "%";
        });
}

// Initial load
document.addEventListener('DOMContentLoaded', updateDrawerShippingBar);

// You may need to trigger `cart:updated` after Ajax cart updates depending on your theme
